module.exports = __webpack_public_path__ + "static/media/image_65.30847e02.png";